export default function (form) {
	return `
		${this.render('form/fields', form.fields)}
		${this.cond('actions' in form, () => this.render('form/actions', form.actions))}
	`;
}
